// material-ui
// import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 * import { ThemeMode } from 'config';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  // const theme = useTheme();

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === ThemeMode.DARK ? logoIconDark : logoIcon} alt="Mantis" width="100" />
     *
     */
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42" fill="none">
      <g clipPath="url(#clip0_2158_57266)">
        <path d="M21.5186 42L0 -1.83588e-06L21 -9.17939e-07L42 0L21.5186 42Z" fill="white" />
        <path d="M22.3935 7.74203L9 14.8255V7.91276V1L22.3935 7.74203Z" fill="#262626" />
        <path d="M18.9371 7.74203L32.3306 14.8255V7.91276V1L18.9371 7.74203Z" fill="#262626" />
        <rect x="17.9287" y="4.88867" width="5.18457" height="5.61662" fill="#262626" />
        <circle cx="21.0002" cy="17.0173" r="2.07296" fill="#262626" />
        <circle cx="21.0002" cy="24.1638" r="2.07296" fill="#262626" />
        <circle cx="21.1804" cy="31.3093" r="2.07296" fill="#262626" />
      </g>
      <defs>
        <clipPath id="clip0_2158_57266">
          <rect width="42" height="42" fill="white" transform="matrix(-1 0 0 1 42 0)" />
        </clipPath>
      </defs>
    </svg>
  );
}
